import ArticleList from '../ArticleList';
import React from 'react';
import agent from '../../agent';
import { connect } from 'react-redux';
import { CHANGE_TAB } from '../../constants/actionTypes';

const YourFeedTab = props => {
    if (props.token) {
        const clickHandler = ev => {
            ev.preventDefault();
            props.onTabClick('feed', agent.Articles.feed, agent.Articles.feed());
        }

        return (
            <li className="nav-item">
                <a href=""
                    className={props.tab === 'feed' ? 'nav-link active' : 'nav-link'}
                    onClick={clickHandler}>
                    Your Feed
                </a>
            </li>
        );
    }
    return null;
};

const GlobalFeedTab = props => {
    const clickHandler = ev => {
        ev.preventDefault();
        props.onTabClick('all', agent.Articles.all, agent.Articles.all());
    };
    return (
        <li className="nav-item">
            <a
                href=""
                className={props.tab === 'all' ? 'nav-link active' : 'nav-link'}
                onClick={clickHandler}>
                Global Feed
            </a>
        </li>
    );
};

const mapStateToProps = state => ({
    ...state.articleList,
    tags: state.home.tags,
    token: state.common.token
});

const mapDispatchToProps = dispatch => ({
    onTabClick: (tab, pager, payload) => dispatch({ type: CHANGE_TAB, tab, pager, payload })
});

const MainView = props => {
    return (
        <div>
            <div className="row" >
                <div className="col-md-12" >
                    <div className="feed-toggle" >
                        <ul className="nav nav-pills outline-active" >

                            <YourFeedTab token={props.token}
                                tab={props.tab}
                                onTabClick={props.onTabClick}
                            />

                            <GlobalFeedTab tab={props.tab}
                                onTabClick={props.onTabClick}
                            />

                        </ul>
                    </div>
                </div>
            </div>
            <div className="row" >
                <div className="nav-object-static col-md-6" >
                    <h4> Teicama kvalitāte par samērīgām cenām! </h4>
                    <ul className="text-list" >
                        <li> Kapu labiekārtošana </li>
                        <li> Izgatavošana, uzstādīšana </li>
                        <li> Seno pieminekļu atjaunošana un tīrīšana </li>
                        <li> Izbraucam uz kapiem un konsultējam </li>
                        <li> Piegāde visā Latvijā! </li>
                    </ul>
                </div>
                <div className="nav-object col-md-6" >
                    <h2 > Pieminekļi un piemiņas plāksnes </h2>
                </div>
            </div>

            <div className="row" >
                <div className="nav-object col-md-6" >
                    <h2 > Apmales </h2> </div>
                <div className="nav-object col-md-6" >
                    <h2 > Laukumi </h2>
                </div>
            </div>
        </div>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(MainView);


// WEBPACK FOOTER //
// ./src/components/Home/MainView.js